/** One box's services as lights in a row, each with its name under it (decisions-r1 #8: box, agent, Paseo, relay, preview, app). */
import { Light, LIGHT_WORDS, type LightState } from '../primitives/Light'
import s from './LightStrip.module.css'

export interface LightSignal {
  key: string
  label: string
  state: LightState
  /** A sentence for the tooltip: what we saw. */
  detail?: string
}

/** "agent down, paseo needs a look; 4 healthy": problems first, for the strip's accessible name. */
export function lightsSummary(lights: LightSignal[]): string {
  const bad = lights.filter((l) => l.state === 'down' || l.state === 'look')
  const rest = lights.length - bad.length
  const parts = bad.map((l) => `${l.label} ${LIGHT_WORDS[l.state]}`)
  return [parts.join(', '), rest ? `${rest} ${rest === lights.length ? 'all fine' : 'other fine or off'}` : ''].filter(Boolean).join('; ')
}

export function LightStrip({ lights }: { lights: LightSignal[] }) {
  if (!lights.length) return null
  return (
    <ul className={s.strip} aria-label={`Services: ${lightsSummary(lights)}`}>
      {lights.map((l) => (
        <li key={l.key} className={s.item} title={`${l.label}: ${LIGHT_WORDS[l.state]}${l.detail ? `. ${l.detail}` : ''}`}>
          <Light state={l.state} />
          <span className={s.name} aria-hidden="true">
            {l.label}
          </span>
        </li>
      ))}
    </ul>
  )
}
